import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { ExpandMoreRounded } from '@mui/icons-material';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { Controller, useFieldArray } from 'react-hook-form';
import { Main, WeekDaysBox, WeekDaysBoxContainer, WorkBoxTitle } from './WorkingHours.styles';
import { shiftEnd, shiftStart, weekDays } from './const';

import { PlusCircled, Calendar, ClockPrimary } from '../SvgComponents';

export const AddButton = ({ onClick }) => (
  <Button
    variant="text"
    sx={{
      paddingLeft: 0,
    }}
    onClick={onClick}
  >
    <PlusCircled />
    <Typography component="span" marginLeft={1} fontWeight={600} textTransform="uppercase">
      Add another
    </Typography>
  </Button>
);

const WorkHours = ({ control }) => {


  // const [updateStaff, { isLoading: isUpdating }] = stockApi.useCreateDealerMutation();

  const { fields, append, remove, update } = useFieldArray({
    name: 'workingHours',
    control,
  });

  const handleToggleWeekDay = (index, value) => {
    const updatedWeekDays = (item) => {
      const weekdays = item.weekdays || [];
      const updatedWeekDay = weekdays.includes(value) ? weekdays.filter((day) => day !== value) : [...weekdays, value];
      return { ...item, weekdays: updatedWeekDay };
    };
    update(index, updatedWeekDays(fields[index]));
  };

  return (
    <Main>
      {fields.map((item, index) => (
        <Card
          key={item.id}
          sx={{
            marginBottom: 3,
          }}
        >
          <CardContent>
            <Box display="flex" justifyContent="space-between">
              <Typography fontWeight={700}>Shift: {index + 1}</Typography>
              {index !== 0 && (
                <IconButton onClick={() => remove(index)}>
                  <DeleteOutlinedIcon />
                </IconButton>
              )}
            </Box>
            <WorkBoxTitle>
              <Calendar />
              <Typography component="span" marginLeft={1}>
                Select week days
              </Typography>
            </WorkBoxTitle>
            <WeekDaysBoxContainer>
              <Controller
                name={`workingHours.${index}.weekdays`}
                control={control}
                rules={{
                  validate: (value) => (value?.length && value.length > 0) || 'Week day required ',
                }}
                render={({ field: { value }, formState: { errors } }) => (
                  <>
                    {weekDays.map((day) => (
                      <WeekDaysBox
                        key={day.id}
                        selected={value?.includes(day.value)}
                        onClick={() => handleToggleWeekDay(index, day.value)}
                      >
                        {day.name}
                      </WeekDaysBox>
                    ))}
                    {errors?.workingHours?.[index]?.weekdays?.message && (
                      <FormHelperText error>{errors?.workingHours?.[index]?.weekdays?.message}</FormHelperText>
                    )}
                  </>
                )}
              />
            </WeekDaysBoxContainer>
            <WorkBoxTitle marginBottom={16}>
              <ClockPrimary />
              <Typography component="span" marginLeft={1}>
                Select work hours
              </Typography>
            </WorkBoxTitle>
            <Grid container spacing={3}>
              <Grid item xs={3}>
                <Controller
                  name={`workingHours.${index}.startTime`}
                  control={control}
                  rules={{
                    required: 'Start time required ' || '',
                  }}
                  render={({ field: { onChange, value }, formState: { errors } }) => (
                    <FormControl fullWidth>
                      <Select
                        value={value}
                        IconComponent={ExpandMoreRounded}
                        error={!!errors?.workingHours?.[index]?.startTime}
                        onChange={(e) => onChange(e.target.value)}
                      >
                        {shiftStart.map((shift) => (
                          <MenuItem key={shift.id} value={shift.value}>
                            {shift.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors?.workingHours?.[index]?.startTime?.message && (
                        <FormHelperText error>{errors?.workingHours?.[index]?.startTime?.message}</FormHelperText>
                      )}
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name={`workingHours.${index}.endTime`}
                  control={control}
                  rules={{ required: 'End time required ' || '' }}
                  render={({ field: { onChange, value }, formState: { errors } }) => (
                    <FormControl fullWidth error={!!errors?.workingHours?.[index]?.endTime}>
                      <Select
                        value={value}
                        IconComponent={ExpandMoreRounded}
                        error={!!errors?.workingHours?.[index]?.endTime}
                        onChange={(e) => onChange(e.target.value)}
                      >
                        {shiftEnd.map((shiftE) => (
                          <MenuItem key={shiftE.id} value={shiftE.value}>
                            {shiftE.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors?.workingHours?.[index]?.endTime?.message && (
                        <FormHelperText error>{errors?.workingHours?.[index]?.endTime?.message}</FormHelperText>
                      )}
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <AddButton onClick={() => append({ weekdays: [], startTime: '', endTime: '' })} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ))}
    </Main>
  );
};

WorkHours.defaultProps = {
  data: undefined,
  handleStep: undefined,
  currentStep: undefined,
  progress: undefined,
};

export default WorkHours;
